import { render, staticRenderFns } from "./getPay.vue?vue&type=template&id=5f57768c&scoped=true&"
import script from "./getPay.vue?vue&type=script&lang=js&"
export * from "./getPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57768c",
  null
  
)

export default component.exports